/* eslint-disable no-unused-vars */
// eslint-disable no-unused-vars
import React, { useState } from 'react';
import { Dashboard as DashboardLayout } from 'layouts';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Button,
  SpeedDial,
  SpeedDialAction,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { isAllowed } from 'helpers';
import { useSelector } from 'react-redux';
import {
  CorporateReport,
  HourlyReport,
  MeasurementReport,
  SendReports,
  TotalsHistorical,
  TotalsHourly,
} from './components';
import { Email, Settings } from '@mui/icons-material';
import clsx from 'clsx';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, pl: 0, pt: 1.5 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

import { makeStyles } from '@mui/styles';
import styles from './styles';

const useStyles = makeStyles(styles);

export default function Reports() {
  const intl = useIntl();
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const { user } = useSelector((state) => state.user);
  const [tapState, setTapState] = useState('0');
  const [open, setOpen] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DashboardLayout title="Reportes">
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection="row"
        flexWrap={{ xs: 'wrap', md: 'nowrap' }}
        alignItems="center"
        width="100%"
        pr={2}
        pt={2}
        pb={0.5}
        gap={1}
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setTapState('0')}
          fullWidth={true}
          className={clsx({ [classes.active]: tapState === '0' })}
        >
          {intl.formatMessage({ id: 'app.reports.totReports.title' })}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setTapState('1')}
          fullWidth={true}
          className={clsx({ [classes.active]: tapState === '1' })}
        >
          Totales por Periodo
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setTapState('2')}
          fullWidth={true}
          className={clsx({ [classes.active]: tapState === '2' })}
        >
          {intl.formatMessage({ id: 'app.reports.hourReports.title' })}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setTapState('3')}
          fullWidth={true}
          className={clsx({ [classes.active]: tapState === '3' })}
        >
          Totales por Periodo Histórico
        </Button>
        {isAllowed(user.permissions, ['download_report_structure']) && (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setTapState('4')}
            fullWidth={true}
            className={clsx({ [classes.active]: tapState === '4' })}
          >
            {intl.formatMessage({ id: 'app.reports.corpStructure.title' })}
          </Button>
        )}
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
        pr={3}
        pl={1.5}
        pt={0.5}
      >
        {tapState === '0' && <MeasurementReport />}
        {tapState === '1' && <TotalsHourly />}
        {tapState === '2' && <HourlyReport />}
        {tapState === '3' && <TotalsHistorical />}
        {tapState === '4' && <CorporateReport />}
      </Box>
      <SpeedDial
        ariaLabel="Configuración"
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          '& .MuiFab-primary': {
            width: 80, // Ajusta el tamaño del botón principal
            height: 80,
            backgroundColor: '#A53693', // Cambia el color de fondo
            '&:hover': {
              backgroundColor: '#6A1A5F',
            },
          },
        }}
        icon={
          <Settings
            sx={{
              width: 40,
              height: 40,
              transform: 'rotate(0deg)',
              transition: 'transform 0.3s ease-in-out',
              '&:hover': {
                transform: 'rotate(180deg)',
                backgroundColor: '#6A1A5F',
              },
            }}
          />
        }
        direction="up"
      >
        <SpeedDialAction
          icon={<Email />}
          onClick={() => handleOpen()}
          tooltipTitle={intl.formatMessage({
            id: 'app.reports.scheduleReport.title',
          })}
          sx={{
            backgroundColor: '#00AFEF',
            color: '#fff',
            width: '60px',
            height: '60px',
            fontSize: '1.5em',
            '&:hover': {
              backgroundColor: 'rgb(0, 146, 199)',
            },
          }}
        />
      </SpeedDial>
      <SendReports open={open} handleClose={handleClose} />
    </DashboardLayout>
  );
}
